module.exports = __webpack_public_path__ + "img/sad.e15930ef.png";